"use strict";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import Account from "../../api/account";
import AutoConfirmedLoadHeader from "../auto_confirmed_load_header";
import InvoiceInputFieldsOwnerMixin from "./invoice_input_fields_owner_mixin";
import LoadAssignerProgress, {
  getLoadAssignerProgressItems
} from "./load_assigner_progress";
import LoadTable from "./load_table";
import LoadSearchArea from "./load_search_area";
import DocumentExceptionArea from "./document_exception_area";
import CarrierChooser from "./carrier_chooser";
import CarrierInvoiceChooser from "./carrier_invoice_chooser";
import DocumentTitle from "react-document-title";
import DisablingButton from "../../components/disabling_button";
import reactUtils from "../../react_utils";
var bem = reactUtils.makeBem("document-group-editor");
function hasGuessedLoadFor(props) {
  return props.loads.guessed.length > 0 || props.loads.selected;
}
function createLoadsInHubtran() {
  return Account.currentSettings().create_loads_in_hubtran;
}
function creatingLoad(isNew) {
  return isNew === true && createLoadsInHubtran();
}
function possibleCarrierChooserNumbering() {
  if (!createLoadsInHubtran()) {
    return /* @__PURE__ */ React.createElement("span", { className: "paragraph__possible-select-load-text-numbering" }, /* @__PURE__ */ React.createElement("strong", null, "2."));
  }
}
function carrierID(props, isNew) {
  if (creatingLoad(isNew)) {
    return props.selectedCarrierID || props.documentBatch.single_carrier && props.documentBatch.carrier_id || null;
  } else {
    return props.selectedCarrierID;
  }
}
function showAssignLoadsContent(props, state) {
  return (!state.showExceptions || state.showExceptions && activeExceptions(props).length > 0) && !state.recentlyResolved;
}
function assignLoadsHeader(props) {
  var selectedLoad = props.loads.selectedLoad;
  var text = "Assign Load to This Document Group";
  if (selectedLoad && !selectedLoad.load.load_is_auto_confirmed) {
    return /* @__PURE__ */ React.createElement("h3", null, text);
  } else if (!selectedLoad) {
    return /* @__PURE__ */ React.createElement("h3", null, text);
  }
}
function userCreatedLoadExists(props) {
  return !!_.findWhere(
    _.map(props.loads.guessed, (load) => load.load),
    { source_system: "hubtran" }
  );
}
function guessedLoads(props) {
  return _.reject(props.loads.guessed, (load) => {
    return load.load.source_system == "hubtran";
  });
}
function possibleSelectLoadTextNumbering(props) {
  if (props.multiCarrier) {
    return /* @__PURE__ */ React.createElement("span", { className: "paragraph__possible-select-load-text-numbering" }, /* @__PURE__ */ React.createElement("strong", null, "1."));
  }
}
function autoConfirmedLoadHeader(props) {
  return /* @__PURE__ */ React.createElement(
    AutoConfirmedLoadHeader,
    {
      carrierInvoice: null,
      load: props.loads.selectedLoad
    }
  );
}
function loadsNotFromEmailCarrier(props, loadState) {
  return !!(props.email.carrier_id && loadState.load.carrier_id !== props.email.carrier_id);
}
function possibleNonMatchingCarrierWarning(props, state) {
  if (!state.showSearch && _.find(
    guessedLoads(props),
    (loadState) => loadsNotFromEmailCarrier(props, loadState)
  )) {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, /* @__PURE__ */ React.createElement("span", null, "At least one of the following loads is assigned to a", " ", Account.carrierTermLower(), " that does not match the", " ", Account.carrierTermLower(), " assigned to this email."));
  }
}
function carrierChooser(props) {
  if ((props.loads.selected || createLoadsInHubtran()) && !props.documentBatch.single_carrier) {
    return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__carrier-chooser" }, possibleMultipleGuessedCarriersNotification(props), /* @__PURE__ */ React.createElement("h6", null, possibleCarrierChooserNumbering(), "Select a ", Account.carrierTermLower(), " for this invoice:"), /* @__PURE__ */ React.createElement(
      CarrierChooser,
      {
        carrierGuesses: props.carrierGuesses(),
        allowIndexingCustomerOnlyDocuments: isIndexCustomerOnlyDocsEnabled(
          props
        ),
        state: props.carrierChooserState,
        onUpdate: props.onCarrierChooserUpdate
      }
    ));
  }
}
function selectedLoadIsUserCreated(props) {
  var selectedLoad = props.loads.selectedLoad;
  return !_.isEmpty(selectedLoad) && selectedLoad.load.source_system === "hubtran";
}
function nonUserCreatedLoadSelected(props) {
  return props.loads.selected && !selectedLoadIsUserCreated(props);
}
function guessedLoadsContent(props, state) {
  if (!state.showSearch) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      LoadTable,
      {
        items: guessedLoads(props),
        highlightChanged: props.highlightReference,
        selectedLoadStateId: props.loads.selected,
        highlightedLoads: _.pluck(guessedLoads(props), "id"),
        loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(props, loadState),
        onSelectionChange: props.setSelectedLoad
      }
    ));
  }
}
function possibleMultipleGuessedCarriersNotification(props) {
  if (props.documentGroup.multiple_guessed_carriers) {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--progress" }, "TriumphPay Audit was unable to automatically assign a", " ", Account.carrierTermLower(), " to this group because multiple different", " ", Account.carrierTermLower(), "s or multiple matching", " ", Account.carrierTermLower(), "s with similar names were detected in the documents.");
  }
}
function activeExceptions(props, givenProps) {
  const effectiveProps = givenProps ? givenProps : props;
  return _.reject(
    effectiveProps.documentGroup.exception_events,
    _.property("resolved_at")
  );
}
function isIndexCustomerOnlyDocsEnabled(props) {
  return Account.currentSettings().allow_indexing_customer_only_documents && props.documentBatch.customer_only;
}
function showInvoiceChooserForCustomerOnlyDocs(props) {
  return props.loads.selected && props.assignCustomerOnlyDocuments && isIndexCustomerOnlyDocsEnabled(props);
}
export default React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  mixins: [InvoiceInputFieldsOwnerMixin],
  newInvoice: { id: "new" },
  getInitialState: function() {
    const hasGuessedLoad = hasGuessedLoadFor(this.props);
    return {
      showExceptions: _.first(activeExceptions(this.props)),
      showSearch: !hasGuessedLoad,
      showGuessed: hasGuessedLoad,
      source_invoice_amount: null,
      source_invoice_number: null
    };
  },
  componentDidMount: function() {
    if (hasGuessedLoadFor(this.props)) {
      this.focusNextField();
    }
  },
  componentWillReceiveProps: function(nextProps) {
    if (this.props.group !== nextProps.group) {
      const hasGuessedLoad = hasGuessedLoadFor(nextProps);
      this.setState({
        showExceptions: _.first(activeExceptions(this.props, nextProps)),
        showSearch: !hasGuessedLoad,
        showGuessed: hasGuessedLoad
      });
    }
    if (nextProps.saving !== this.props.saving) {
      this.setState({ saving: nextProps.saving });
    }
  },
  // STATE
  assignLoad: function(isNew) {
    let selectedLoad;
    if (creatingLoad(isNew)) {
      selectedLoad = "new";
    } else {
      selectedLoad = this.props.loads.selected;
    }
    var isFirstLoad = !this.props.currentlyAssignedInvoiceForGroup;
    const carrierInvoice = {};
    ["source_invoice_number", "source_invoice_amount"].forEach((field) => {
      if (this.state[field]) {
        carrierInvoice[field] = this.state[field];
      }
    });
    const assignCustomerOnlyDocuments = this.props.assignCustomerOnlyDocuments;
    this.setState({ saving: true });
    this.props.assignCurrentGroupToLoadAndInvoiceId(
      selectedLoad,
      this.props.getSelectedInvoiceForGroup(this.newInvoice).id,
      carrierInvoice,
      carrierID(this.props, isNew),
      isFirstLoad,
      assignCustomerOnlyDocuments,
      this.props.shipmentDocumentSelections
    );
  },
  toggleExceptions: function() {
    this.setState({ showExceptions: !this.state.showExceptions });
  },
  showSearch: function() {
    this.setState({ showSearch: true });
  },
  cancelSearch: function() {
    this.setState({ showSearch: false });
    this.focusNextField();
  },
  carrierSelected: function(carrier) {
    this.setState({ carrier });
  },
  // RENDER
  render: function() {
    return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "TriumphPay Audit \u2013 Assign Loads" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__root" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__scrollable-area" }, this.reportProblemContent(), this.assignLoadsContent()), this.progressArea()));
  },
  assignLoadsContent: function() {
    if (showAssignLoadsContent(this.props, this.state)) {
      return /* @__PURE__ */ React.createElement("div", null, assignLoadsHeader(this.props), this.selectLoadText(), this.documentGroup(), this.possibleExceptionsLink());
    }
  },
  documentGroup: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__group") }, /* @__PURE__ */ React.createElement("div", { className: bem("__group-title") }, this.props.group.name), possibleNonMatchingCarrierWarning(this.props, this.state), this.loadSearchArea(), guessedLoadsContent(this.props, this.state));
  },
  possibleExceptionsLink: function() {
    if (!this.state.showExceptions) {
      return /* @__PURE__ */ React.createElement("p", { className: "load-assigner__report-problem" }, "Still issues?", " ", /* @__PURE__ */ React.createElement("a", { onClick: this.toggleExceptions }, "Create an exception"));
    }
  },
  selectLoadText: function() {
    if (!this.state.showSearch) {
      var selectedLoad = this.props.loads.selectedLoad;
      var text = selectedLoad && selectedLoad.load.load_is_auto_confirmed ? autoConfirmedLoadHeader(this.props) : "Select a load from the loads we identified in the documents. ";
      return /* @__PURE__ */ React.createElement("div", { className: "paragraph" }, /* @__PURE__ */ React.createElement("span", null, possibleSelectLoadTextNumbering(this.props), text, "Not the right ones?", " ", /* @__PURE__ */ React.createElement("a", { onClick: this.showSearch }, "Search for another one"), "."));
    }
  },
  progressArea: function() {
    if (this.state.tab !== "exception") {
      return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__save-buttons" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__save-buttons-inner" }, this.invoiceInputFields(), carrierChooser(this.props), this.invoiceChooser(), this.possibleCreateLoadButton(), this.possibleMessageOrSave()));
    }
  },
  invoiceChooser: function() {
    if (nonUserCreatedLoadSelected(this.props) && this.props.selectedCarrierID || showInvoiceChooserForCustomerOnlyDocs(this.props)) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        CarrierInvoiceChooser,
        {
          loadID: this.props.loads.selectedLoad.load.load_id,
          invoicesForGroup: this.props.invoicesForGroup,
          initialInvoiceId: _.first(
            _.compact(
              _.pluck(this.props.group.documents, "carrier_invoice_id")
            )
          ),
          selectedInvoice: this.props.getSelectedInvoiceForGroup(
            this.newInvoice
          ),
          carrierID: this.props.selectedCarrierID,
          group: this.props.group,
          newInvoice: this.newInvoice,
          currentlyAssignedInvoice: this.props.currentlyAssignedInvoiceForGroup,
          invoiceSelected: this.props.setSelectedInvoiceForGroup
        }
      ));
    }
  },
  possibleCreateLoadButton: function() {
    if (createLoadsInHubtran() && !nonUserCreatedLoadSelected(this.props)) {
      if (!this.props.selectedCarrierID) {
        return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__possible-create-load-button" }, /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select a ", Account.carrierTermLower(), " to continue"));
      }
      if (userCreatedLoadExists(this.props)) {
        var buttonText = "Edit Existing Created Load";
      } else {
        var buttonText = "Create a Load";
      }
      return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__possible-create-load-button" }, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabledText: buttonText,
          className: "button--progress",
          disabled: this.state.saving,
          onClick: _.partial(this.assignLoad, true)
        },
        buttonText
      ));
    }
  },
  possibleMessageOrSave() {
    if (!createLoadsInHubtran() || nonUserCreatedLoadSelected(this.props)) {
      return this.messageOrSave();
    }
  },
  messageOrSave: function() {
    let button;
    if (this.state.saving) {
      button = /* @__PURE__ */ React.createElement("button", { disabled: true }, "Saving...");
    } else if (this.props.loads.selected && this.props.selectedCarrierID && this.props.getSelectedInvoiceForGroup(this.newInvoice)) {
      let buttonText = "Continue";
      if (Account.indexAuditSplitEnabled()) {
        buttonText = "Submit";
      }
      button = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "button--progress ", onClick: this.assignLoad }, buttonText));
    } else if (this.props.loads.selected && this.props.assignCustomerOnlyDocuments && isIndexCustomerOnlyDocsEnabled(this.props)) {
      let buttonText = "Continue assigning customer only documents";
      if (Account.indexAuditSplitEnabled()) {
        buttonText = "Submit customer only documents";
      }
      button = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "button--progress ", onClick: this.assignLoad }, buttonText));
    } else if (this.props.loads.selected && this.props.selectedCarrierID) {
      button = /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select an invoice option to continue");
    } else if (this.props.loads.selected) {
      button = /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select a ", Account.carrierTermLower(), " to continue");
    } else {
      button = /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select a load to continue");
    }
    const progressItems = getLoadAssignerProgressItems(
      this.props.loads.selectedLoad,
      this.props.documentBatch,
      this.props.documentGroup,
      this.invoiceDataEntered(),
      this.props.shipmentDocumentSelections,
      false,
      this.props.documentLoadRelationships
    );
    return /* @__PURE__ */ React.createElement("div", { className: bem("__actions") }, /* @__PURE__ */ React.createElement(LoadAssignerProgress, { content: button, items: progressItems }));
  },
  recentlyResolved: function() {
    this.setState({ recentlyResolved: true });
  },
  closeExceptions: function() {
    this.setState({ recentlyResolved: false, showExceptions: false });
  },
  reportProblemContent: function() {
    if (this.state.showExceptions || !this.state.showExceptions && this.state.recentlyResolved) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "load-assigner__document-exception-area panel",
          ref: "problemContent"
        },
        /* @__PURE__ */ React.createElement(
          DocumentExceptionArea,
          {
            closeExceptions: this.closeExceptions,
            location: this.props.location,
            recentlyResolved: this.recentlyResolved,
            hasMore: this.props.hasMore,
            documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
            model: this.props.model,
            email: this.props.email,
            carrier: this.props.carrier,
            selectedLoad: this.props.loads.selectedLoad,
            documentGroup: this.props.documentGroup,
            exceptionResolver: this.props.exceptionResolver,
            exceptionCreator: this.props.exceptionCreator,
            exceptionUpdater: this.props.exceptionUpdater,
            exceptions: activeExceptions(this.props),
            scrollUp: this.scrollUp,
            onCancel: this.toggleExceptions
          }
        )
      );
    }
  },
  loadSearchArea: function() {
    if (this.state.showSearch) {
      return /* @__PURE__ */ React.createElement(
        LoadSearchArea,
        {
          loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(this.props, loadState),
          carrier: this.props.carrier,
          selectedLoadStateId: this.props.loads.selected,
          highlightedLoads: _.pluck(guessedLoads(this.props), "id"),
          searcher: this.props.searcher,
          onSelectionChange: this.props.setSelectedLoad,
          onCancel: this.cancelSearch,
          multiCarrier: this.props.multiCarrier,
          highlightReference: this.props.highlightReference
        }
      );
    }
  },
  scrollUp: function() {
    const container = ReactDOM.findDOMNode(this.refs.problemContent);
    container.scrollIntoView();
  }
});
